import { Response } from "@interfaces/response";
import { baseApi } from "./baseApi";
import { PortalUser } from "@interfaces/portalUsers";
import { UUID } from "crypto";

const portalUserApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPortalUsers: build.query<PortalUser, string>({
            query: (userId) => ({
                url: `usuarios_portal/${userId}`,
            }),
            transformResponse: (response: Response<PortalUser>) => {
                return response.data;
            },
        }),
        postChangeEmailUsuarioPortal: build.mutation<void, { userId: UUID; email: string }>({
            query: ({ userId, email }) => ({
                url: `usuarios_portal/${userId}/change-email`,
                method: "POST",
                body: { email },
            }),
        }),
    }),
});

export const { useLazyGetPortalUsersQuery, usePostChangeEmailUsuarioPortalMutation } = portalUserApi;
